import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";
import DataTable from "react-data-table-component";
import ActionLoader from "../../components/loader/ActionLoader";

const Actions = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';

    const [currentPage, setCurrentPage] = useState(1);
    const [rowPerPage, setRowPerPage] = useState(10);

    const tableColumns = [
        { name: 'Username', selector: row => row.uname },
        { name: 'Department', selector: row => row.department },
        { name: 'Action', selector: row => row.action },
        { name: 'Logged At', selector: row => row.loggeddate }
    ];

    const { data: logs, isLoading: isLoadingLogs, error: errorLogs } = useQuery({
        queryKey: ['logs', departmentslug, currentPage, rowPerPage],
        queryFn: async () => {
            const res = await axios.get(`logs?department=${departmentslug}&page=${currentPage}&rows_per_page=${rowPerPage}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!departmentslug,
        retry: 1
    });

    useEffect(() => {
        if (errorLogs) {
            if (errorLogs.response?.data?.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorLogs, navigate]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const handleRowsPerPageChange = (newPerPage) => {
        setRowPerPage(newPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    return (
        <div className="actions">
            <div className="page-header">
                <div className="title">
                    <h1>Actions</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to="/logs/actions">Logs</NavLink>
                        </li>
                        <li>
                            <span>Actions</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="panels">
                <div className="left-panel">
                    <DataTable 
                        columns={tableColumns} 
                        data={logs?.logs || []} 
                        progressPending={isLoadingLogs} 
                        progressComponent={<ActionLoader />} 
                        pagination 
                        paginationServer 
                        paginationTotalRows={logs?.totalRows || 0} 
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        onChangePage={handlePageChange}
                        dense
                        highlightOnHover
                        responsive 
                    />
                </div>
            </div>
        </div>
    )
}

export default Actions;
